import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper/modules";
import mright from "../../assets/icons/icon-mright.svg";
import { dataHandlers } from "../../utils/objectHandlers";
import { useSelector, useDispatch } from "react-redux";
import { fetchElementsCategories, fetchElements } from "../../Store/reducers/elementsSlice";
import AppConfig from "../../config/AppConfig";
import FullCategoryElements from "./Elements/FullcategoryElements"; 


const ElementGroup = ({
  category,
  setSwipers,
  handleNextSlide,
  handlePrevSlide,
  setSelectedCategory,
  handleAddSvg,
  handleDragStart,
}) => {
  const dispatch = useDispatch();

  const [currentSlide, setCurrentSlide] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const prevSlideRef = useRef(currentSlide);

  useEffect(() => {
    // When the slide index reaches a threshold (here, multiples of 13)
    if (
      currentSlide % 10 === 0 &&
      currentSlide !== 0 &&
      currentSlide > prevSlideRef.current
    ) {
      setCurrentSlide(0);
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      dispatch(fetchElements({ page: nextPage, categoryId: category.id }));
    }
    prevSlideRef.current = currentSlide;
  }, [currentSlide, currentPage, category.id, dispatch]);

  if (!category.elements || category.elements.length === 0) {
    return null;
  }

  return (
    <div className="mb-5">
      <div className="flex justify-between w-full">
        <div className="font-semibold text-black font-montserrat text-[11px] leading-[12.19px]">
          {category.title} ({category.elements.length})
        </div>
        {category.elements.length > 2 && (
          <button
            className="font-semibold text-black font-montserrat text-[10px] leading-[12.19px]"
            onClick={() => setSelectedCategory(category)}
          >
            Show All
          </button>
        )}
      </div>
      <div className="relative">
      
        <Swiper
          modules={[Navigation]}
          spaceBetween={7}
          slidesPerView={3}
          navigation={false}
          className="mt-2 "
          loop={false}
          allowTouchMove={false}
          onSwiper={(swiper) =>
            setSwipers((prev) => ({ ...prev, [category.id]: swiper }))
          }
          onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
        >
          {category.elements.map((element, index) => (
            <SwiperSlide key={element.id || index}>
              <img
                src={`${AppConfig.storageUrl}/${element.image}`}
                alt={`Element ${index}`}
                className="w-[40px] h-[40px] object-cover cursor-pointer ml-3"
                draggable
                onDragStart={(e) => handleDragStart(e, element)}
                onClick={() => handleAddSvg(element)}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <img
          src={mright}
          alt="Next Icon"
          className="absolute top-1/2 right-[-16px] transform -translate-y-1/2 w-[22px] h-[22px] cursor-pointer"
          onClick={() => handleNextSlide(category.id)}
        />
        <img
          src={mright}
          alt="Prev Icon"
          className="absolute top-1/2 left-[-16px] transform -translate-y-1/2 w-[22px] h-[22px] cursor-pointer rotate-180"
          onClick={() => handlePrevSlide(category.id)}
        />
        
      </div>
    </div>
  );
};

const Elements = ({ searchQuery = "" }) => {
  const dispatch = useDispatch();
  const fabricCanvas = useSelector((state) => state.fabricCanvas.fabricCanvas);
  const { elements: categories, status } = useSelector((state) => state.elements);

  const [swipers, setSwipers] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    dispatch(fetchElementsCategories({ searchQuery : searchQuery }));
  }, [dispatch, searchQuery]);

  const handleDragStart = (e, element) => {
    const fullUrl = `${AppConfig.storageUrl}/${element.image}`;
    e.dataTransfer.setData("svg", fullUrl);
  };

  const handleAddSvg = (element) => {
    if (fabricCanvas) {
      const url = `${AppConfig.storageUrl}/${element.image}`;
      const centerX = fabricCanvas.getWidth() / 2;
      const centerY = fabricCanvas.getHeight() / 2;
      dataHandlers.svg(url, fabricCanvas,{ left: centerX, top: centerY });
      
    }
  };

  const handleNextSlide = (id) => {
    if (swipers[id]) {
      swipers[id].slideNext();
    }
  };

  const handlePrevSlide = (id) => {
    if (swipers[id]) {
      swipers[id].slidePrev();
    }
  };

  // Filter categories based on search query
  // const lowerCaseQuery = searchQuery.toLowerCase();
  // const filteredCategories = categories.filter((category) => {
  //   const matches =
  //     category.title.toLowerCase().includes(lowerCaseQuery) ||
  //     category.id.toString().includes(lowerCaseQuery) ||
  //     category.elements.some((element) => {
  //       const imageName = element.image.split("/").pop().toLowerCase();
  //       return imageName.includes(lowerCaseQuery);
  //     });
  //   return matches;
  // });

  return (
    <>
      {selectedCategory ? (
        
        <FullCategoryElements
          categoryId={selectedCategory.id}
          setSelectedCategory={setSelectedCategory}
        />
      ) : (
        <div className="h-[460px] overflow-y-scroll custom-scrollbar p-4">
          {categories.map((category) => (
            <ElementGroup
              key={category.id}
              category={category}
              setSwipers={setSwipers}
              handleNextSlide={handleNextSlide}
              handlePrevSlide={handlePrevSlide}
              setSelectedCategory={setSelectedCategory}
              handleAddSvg={handleAddSvg}
              handleDragStart={handleDragStart}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default Elements;
